import React from 'react';
import Marquee from "react-fast-marquee";
import i18n from '../../../i18n/i18n';

import LazyImage from '../../../components/LazyImage';

import socarLogo from "../../../images/brands/socar-logo.png";
import uemLogo from "../../../images/brands/uem-logo.png";
import mrcbLogo from "../../../images/brands/mrcb-logo.png";
import petronasLogo from "../../../images/brands/petronas-logo.png";
import chinaPressLogo from "../../../images/brands/chinapress-logo.png";
import semasaParkingLogo from "../../../images/brands/semasa-parking-logo.png";
import metroParkingLogo from "../../../images/brands/metro-parking-logo.png";
import parkRiteLogo from "../../../images/brands/parkrite-logo.png";
import scpParkingLogo from "../../../images/brands/scp-parking-logo.png";
import muliaLogo from "../../../images/brands/mulia-logo.png";
import wilsonParkingLogo from "../../../images/brands/wilson-parking-logo.png";
import parkspotsLogo from "../../../images/brands/parkspots-logo.png";

const BusinessPartnersBanner = () => {
  return (
    <div className="w-full bg-white p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center my-[15px]">
        <div className="text-[15px] text-black font-bold text-center md:text-[20px]">{i18n.t("bulkListing.businessPartnersBanner.title")}</div>
        <Marquee className="justify-center pb-[10px]" speed={40} gradient={false} pauseOnHover={true}>
          <LazyImage className="h-[25px] m-[20px]" src={socarLogo} alt="socar-logo" />
          <LazyImage className="h-[60px] m-[20px]" src={uemLogo} alt="uem-logo" />
          <LazyImage className="h-[50px] m-[20px]" src={mrcbLogo} alt="mrcb-logo" />
          <LazyImage className="h-[50px] m-[20px]" src={petronasLogo} alt="petronas-logo" />
          <LazyImage className="h-[50px] m-[20px]" src={chinaPressLogo} alt="china-press-logo" />
          <LazyImage className="h-[50px] m-[20px]" src={semasaParkingLogo} alt="semasa-parking-logo" />
          <LazyImage className="h-[50px] m-[20px]" src={metroParkingLogo} alt="metro-parking-logo" />
          <LazyImage className="h-[30px] m-[20px]" src={parkRiteLogo} alt="park-rite-logo" />
          <LazyImage className="h-[40px] m-[20px]" src={scpParkingLogo} alt="scp-parking-logo" />
          <LazyImage className="h-[50px] m-[20px]" src={muliaLogo} alt="mulia-logo" />
          <LazyImage className="h-[30px] m-[20px]" src={wilsonParkingLogo} alt="wilson-parking-logo" />
          <LazyImage className="h-[50px] m-[20px]" src={parkspotsLogo} alt="parkspots-logo" />
        </Marquee>
      </div>
    </div>
  )
}

export default BusinessPartnersBanner;